import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "editable-cell" }
const _hoisted_2 = {
  key: 0,
  class: "date-picker-component date-field-container__date-picker-component"
}
const _hoisted_3 = {
  key: 1,
  class: "text-field-container"
}
const _hoisted_4 = ["type", "placeholder"]

import { i18n } from '@/i18n';
import { computed, onMounted, ref, watch } from 'vue';
import { filterStringNumberUndefinedToString } from '@/coreDomainsModule/extends/string';
import AppDatePicker from '@/corePagesModule/components/AppDatePicker.vue';
import { KeyType } from '../interface/tableContentHeaders';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { IDate } from '@/coreDomainsModule/date';

// emits

export default /*@__PURE__*/_defineComponent({
  __name: 'EditableTableCell',
  props: {
    inputType: { default: 'string' },
    textValue: { default: '' },
    placeholder: { default: '入力してください' },
    format: { default: 'yyyy-MM-dd' },
    disabledDates: { type: [Function, Array], default: () => [] }
  },
  emits: ["changeText", "changeDateValue"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

//変数
const t = i18n.t;
const locale = computed(() => i18n.locale);

const props = __props;

const textValue = ref<string | number>(props.textValue);
const dateValue = ref<Date | null>(null);
//computed
const date = computed({
  /**
   * 値を取得する
   */
  get: () => {
    return dateValue.value;
  },
  /**
   * 値を設定する
   * @param value -値
   */
  set: (value) => {
    // 値に変更があると呼ばれるsetter
    if (!value) {
      return;
    }
    dateValue.value = value;
    emits('changeDateValue', DateService.convertDateToIDate(value));
  },
});

const textComputed = computed({
  /**
   * 値を取得する
   */
  get: () => props.textValue,
  /**
   * 値を設定する
   * @param value -値
   */
  set: (value) => {
    // 呼び出し元に反映させる用
    textValue.value = filterStringNumberUndefinedToString(value);
    emits('changeText', filterStringNumberUndefinedToString(value));
  },
});

// イベント
onMounted(() => {
  textValue.value = props.textValue;
  if (props.inputType === 'IDate') {
    dateValue.value = props.textValue ? DateService.convertDateStrToDateWithSlash(props.textValue) : null;
  }
});

watch(
  () => props.textValue,
  () => {
    if (props.inputType === 'IDate') {
      dateValue.value = props.textValue ? DateService.convertDateStrToDateWithSlash(props.textValue) : null;
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.inputType === 'IDate')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(AppDatePicker, {
            modelValue: date.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((date).value = $event)),
            class: "date-field__input",
            "mode-height": 1,
            format: _ctx.format,
            "enable-time-picker": true,
            "month-change-on-scroll": false,
            teleport: true,
            "disabled-dates": _ctx.disabledDates,
            "week-start": "0",
            locale: locale.value,
            placeholder: _unref(t)('日付を選択'),
            "select-text": _unref(t)('選択'),
            "cancel-text": _unref(t)('キャンセル'),
            "show-now-button": true,
            clearable: false,
            "now-button-label": _unref(t)('現在を選択'),
            pad: ""
          }, null, 8, ["modelValue", "format", "disabled-dates", "locale", "placeholder", "select-text", "cancel-text", "now-button-label"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.inputType === 'string' || _ctx.inputType === 'number')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((textComputed).value = $event)),
            type: _ctx.inputType,
            class: "text-input text-field-container__text-input rounded-base-middle",
            placeholder: _unref(t)(_ctx.placeholder)
          }, null, 8, _hoisted_4), [
            [_vModelDynamic, textComputed.value]
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})